
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualiseringar',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Ange ett tal',
	'maxValuePlaceholder': 'Ange ett tal',
	'customRangeErrorMessage': 'Värdet måste vara ett tal',
	'propFillColor': 'Fyllningsfärg',
	'propBorderColor': 'Kantlinjefärg',
	'propColorPalette': 'Aktuell färgpalett',
	'propColorPaletteChangeLabel': 'Ändra färgpalett',
	'propNewColorPaletteLabel': 'Skapa en anpassad färgpalett',
	'propNewHeatPaletteLabel': 'Skapa en anpassad värmepalett',
	'propDonutRadius': 'Ringradie',
	'showTitleLabel': 'Visa rubrik',
	'titleTypeLabel': 'Rubriktyp',
	'smartTitleLabel': 'Smart rubrik',
	'customTitleLabel': 'Anpassad rubrik',
	'noTitleLabel': 'Ingen titel',
	'propHeatScalePalette': 'Aktuell värmepalett',
	'propHeatPaletteChangeLabel': 'Ändra värmepalett',
	'propMaintainAxisScales': 'Behåll axelskala',
	'propLineAndSymbolColor': 'Linje- och symbolfärg',
	'propLineAndSymbolPalette': 'Linje- och symbolfärgpalett',
	'propElementColor': 'Elementfärg',
	'propColumnColor': 'Stapelfärg',
	'propColumnPalette': 'Kolumnfärgpalett',
	'propColumnHeatPalette': 'Kolumnvärmepalett',
	'propBarColor': 'Stapelfärg',
	'propGoalColor': 'Färg på mål',
	'propToColor': 'Till-färg',
	'propFromColor': 'Från-färg',
	'propNumberValidationErrorMessageId': 'Ange ett tal',
	'fontSizeAuto': 'Auto',
	'propAutoBinCount': 'Antal grupper',
	'propAutoBinToggle': 'Automatisk gruppering',
	'tabName_general': 'Allmänt',
	'tabName_visDetails': 'Detaljer',
	'tabName_animation': 'Animering',
	'tabName_mediaDetails': 'Mediedetaljer',
	'tabName_webDetails': 'Webbsidesdetaljer',
	'tabName_imageDetails': 'Bilddetaljer',
	'tabName_visualization': 'Visualisering',
	'tabName_text': 'Text',
	'sectionName_colorsAndThemes': 'Färg och teman',
	'sectionName_appearance': 'Utseende',
	'sectionName_general': 'Allmänt',
	'sectionName_colorPalette': 'Färg',
	'sectionName_axis': 'Axel',
	'sectionName_axis_label': 'Axel',
	'sectionName_legend': 'Teckenförklaring',
	'sectionName_chart': 'Diagram',
	'sectionName_regionLayer': 'Regionsskikt',
	'sectionName_pointLayer': 'Punktskikt',
	'sectionName_latLongLayer': 'Latitud-/longitudskikt',
	'sectionName_pathLayer': 'Sökvägsskikt',
	'propTransparencyDescription': 'Gör objektet mer eller mindre transparent. Skriv ett värde från 0 till 100.',
	'smart_annotation_unauthorized': 'Annoteringar: obehörig åtkomst',
	'smart_annotation_method': 'Annoteringar: metod ej tillåten',
	'smart_annotation_media': 'Annoteringar: medietyp ej tillåten',
	'smart_annotation_input': 'Annoteringar: ogiltiga indata',
	'smart_annotation_internal': 'Annoteringar: internt systemfel',
	'smart_annotation_generic_error': 'Annoteringar: tjänstefel',
	'smart_annotation_dialog_title': 'Insikter',
	'smart_errors': 'Annoteringsfel:',
	'smart_warnings': 'Annoteringsvarningar:',
	'smart_annotation_insight_icon_title': 'Insikter',
	'smart_annotations_toggle_on': 'Aktivera insikter',
	'smart_annotations_toggle_off': 'Avaktivera insikter',
	'smart_annotation_insight_unavailable': 'Insikter är för närvarande inte tillgängliga',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Insikter är inte tillgängliga när % högsta-/lägstafilter tillämpas.',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Prognos är inte tillgänglig när % högsta-/lägstafilter tillämpas.',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Insikter är inte tillgängliga när ett högsta-/lägstafilter tillämpas och det finns mer än en kolumn i fältet.',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Prognos är inte tillgänglig när ett högsta-/lägstafilter tillämpas och det finns mer än en kolumn i fältet.',
	'forecast_title': 'Prognos',
	'forecast_toggle_on': 'Aktivera prognostisering',
	'forecast_toggle_off': 'Avaktivera prognostisering',
	'statDetailsPerspectiveTitle': 'Analys',
	'emptyStatDetailsPanel': 'Ingen ytterligare analys är tillgänglig för aktuell visualisering.',
	'predict_errors': 'Analysfel',
	'predict_warnings': 'Analysvarningar',
	'fpd_invalid_data_source': 'Datakällan har inte någon associerade smartmodul',
	'fpd_network_issue': 'Ett problem uppstod vid utförande av en analys mot den här datakällan',
	'fpd_data_source_category': 'Smartmodul saknas',
	'fpd_response_errors': 'Fel för rekommenderad styrfunktion',
	'fpd_response_warnings': 'Varningar för rekommenderad styrfunktion',
	'catalyst_service_bad_request': 'Ogiltig begäran',
	'catalyst_service_unkown_Id': 'Okänt begäran-ID hittades',
	'catalyst_service_internal_server_error': 'Internt serverfel',
	'catalyst_service_generic_error': 'Catalyst-tjänstfel',
	'catalyst_service_error': 'Tjänsten är för närvarande inte tillgänglig',
	'propLegendPosition': 'Teckenförklaringsplacering',
	'propLeft': 'Vänster',
	'propRight': 'Höger',
	'propTop': 'Mest använda',
	'propBottom': 'Nederst',
	'propNone': 'Inget',
	'propLegendDisplay': 'Visa teckenförklaring',
	'targetThicknessPlaceHolder': '%{min} till %{max}',
	'targetThicknessErrorMsg': 'Ange ett heltal från %{min} till %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Styrfunktioner (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'valda)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Återställ till standard',
	'possibelKeyDriver_AddNewDrivers': 'Lägg till fler styrfunktioner',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Sök för att lägga till fler styrfunktioner',
	'possibleKeyDrivers_MaxPossibleReached': 'Avmarkera några styrfunktioner för att lägga till eller välja andra',
	'possibleKeyDrivers_Recommended': 'Rekommenderat',
	'visRecommendedTypes': 'Rekommenderade visualiseringstyper',
	'visRecommender_smartsfailure': 'visualiseringsrekommendationer är inte tillgängliga för närvarande',
	'visMore': 'Fler...',
	'visMoreTooltip': 'Fler visualiseringar',
	'visOtherTypes': 'Andra visualiseringstyper',
	'visChange': 'Ändra visualisering',
	'automaticTypeCaption': 'Automatisk',
	'propVisType': 'Visualiseringstyper',
	'dlg_loading': 'Läser in...',
	'snippetListChartCaption': 'Kodstyckelista',
	'convoClusterChartCaption': 'Konversationskluster',
	'areaChartCaption': 'Yta',
	'barChartCaption': 'Liggande stapel',
	'columnChartCaption': 'Stapel',
	'stackedbarChartCaption': 'Staplad liggande stapel',
	'stackedcolumnChartCaption': 'Staplad stapel',
	'bubbleChartCaption': 'Bubbla',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Styrfunktionsanalys',
	'scatterChartCaption': 'Spridning',
	'lineChartCaption': 'Linje',
	'pointChartCaption': 'Punkt',
	'heatChartCaption': 'Värmekarta',
	'bulletChartCaption': 'Kuldiagram',
	'waterfallChartCaption': 'Vattenfall',
	'pieChartCaption': 'Cirkel',
	'mapChartCaption': 'Karta',
	'radialBarChartCaption': 'Radar',
	'compositeChartCaption': 'Linje och stapel',
	'wordCloudChartCaption': 'Ordmoln',
	'networkChartCaption': 'Nätverk',
	'relationshipNetworkChartCaption': 'Relationsnätverk',
	'treemapChartCaption': 'Trädkarta',
	'packedBubbleChartCaption': 'Packad bubbla',
	'hierarcicalPackedBubbleChartCaption': 'Hierarkisk bubbla',
	'spiralChartCaption': 'Spiral',
	'decisionTreeChartCaption': 'Beslutsträd',
	'legacyMapChartCaption': 'Avvecklad karta',
	'sunburstChartCaption': 'Soldiagram',
	'visUsageComparison': 'Jämförelse',
	'visUsageRelationships': 'Relationer',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Delar till helheten',
	'visUsageGeospatial': 'Rumsanalys',
	'visUsageAdvanced': 'Avancerad analys',
	'visUsageTablesAndSummary': 'Tabeller och summering',
	'visUsageSocialInsights': 'Sociala insikter',
	'visUsageOther': 'Annan',
	'autoBinActionText': 'Automatisk gruppering',
	'filterAutobinActionText': 'Filtrera bin',
	'memberCalculationActionText': 'Medlemsberäkning',
	'toolbarActionCalculation': 'Beräkning',
	'toolbarActionEditCalculation': 'Ändra beräkning',
	'topBottomRankLabel': 'Rangordning (%{label})',
	'toolbarDeleteFilterActionText': 'Ta bort filter',
	'toolbarActionTopKeyDrivers': 'Visa styrfunktioner',
	'toolbarActionCustomGroup': 'Anpassad grupp',
	'canNotCreateCustomGroup': 'Det går inte att skapa den anpassade gruppen.',
	'aria_label_datatable': 'Datatabell',
	'summaryCaption': 'Sammanfattning',
	'MeasuresCaption': 'Mått',
	'MeasuresGroupCaption': 'Måttgrupp (%{count})',
	'ValuesCaption': 'Värden',
	'turnInsightsOn': 'Aktivera insikter',
	'turnInsightsOff': 'Avaktivera insikter',
	'decisionRules': 'Regler',
	'decisionTree': 'Träddiagram',
	'decisionSunburst': 'Trädsoldiagram',
	'switchToDecisionRules': 'Växla till beslutsregler',
	'switchToDecisionTree': 'Växla till beslutsträd',
	'data_group_less_then': 'mindre än %{rangeTo}',
	'data_group_to': '%{rangeFrom} till < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} och över',
	'nullValueContent': '(inget värde)',
	'sum': 'Summa',
	'count': 'Antal',
	'countdistinct': 'Antal distinkta',
	'avg': 'Medel',
	'min': 'Minimum',
	'max': 'Maximum',
	'automatic': 'Anpassad',
	'variance': 'Variansvärde',
	'stddev': 'Standardavvikelse',
	'median': 'Medianvärde',
	'calculated': 'Beräknat',
	'none': 'Inget',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'Promptscenariot hanteras inte.',
	'preAggregateLabel': 'Tillämpa promptvärden från den här datakällan',
	'postAggregateLabel': 'Tillämpa promptvärden i rapporten',
	'preAggregateText': 'Intervallet använder värden i datakällan inte de värden som visas på kontrollpanelen.',
	'defaultAggregation_count': 'Antal',
	'defaultAggregation_countdistinct': 'Antal distinkta',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Medel',
	'defaultAggregation_sum': 'Summa',
	'defaultAggregation_auto': 'Automatisk (%{aggregationType})',
	'keydriver_average': 'Medel',
	'keydriver_up_down': 'Markerade grupper med högt eller lågt medelvärde har större inverkan på målet. Grupper med ovanligt högt eller lågt medelvärde har störst inverkan.',
	'keydriver_different': 'Markerade grupper har fördelning som skiljer sig signifikant från genomsnittlig fördelning. Dessa grupper har större inverkan på målet.',
	'topOperator': 'Mest använda',
	'bottomOperator': 'Nederst',
	'topBottomFact': '%{operator} %{value}%{percent} efter %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Ta bort antal högsta och lägsta',
	'deleteTopBottomPercent': 'Ta bort % för högsta och lägsta',
	'topBottomTitle': 'Endast detta objekt',
	'deleteTopBottom': 'Ta bort antal högsta och lägsta',
	'editTopBottom': 'Ändra antal högsta och lägsta',
	'editTopBottomCount': 'Ändra antal högsta och lägsta',
	'editTopBottomPercent': 'Ändra % för högsta och lägsta',
	'ariaDeleteTopBottomCountLabel': 'Tryck på Delete om du vill ta bort antalet för högsta och lägsta.',
	'ariaDeleteTopBottomPercentLabel': 'Tryck på Delete för att ta bort procent för högsta och lägsta.',
	'ariaEditTopBottomCountLabel': 'Tryck på Enter om du vill ändra antalet för högsta och lägsta.',
	'ariaEditTopBottomPercentLabel': 'Tryck på Enter om du vill ändra procent för högsta och lägsta.',
	'ariaDeleteDrillStateLabel': 'Tryck på Enter om du vill ändra antalet för högsta och lägsta.',
	'drillUpStateTitle': 'Borra uppåt',
	'drillDownStateTitle': 'Borra nedåt',
	'ariaEditTopBottomLabel': 'Tryck på Enter om du vill ändra antalet för högsta och lägsta.',
	'ariaDeleteTopBottomLabel': 'Tryck på Delete om du vill ta bort antalet för högsta och lägsta.',
	'allKeyDriversLabel': 'Automatiskt (alla styrfunktioner)',
	'filter_drag_and_drop_single_dock': 'Dra data hit för att filtrera.',
	'filter_drag_and_drop_all_tabs': 'Dra data hit för att filtrera alla flikar.',
	'filter_drag_and_drop_current_tab': 'Dra data hit för att filtrera den här fliken.',
	'filter_empty_consume_mode': 'Inga filter har tillämpats.',
	'filterClearAllItems': 'Rensa alla filter',
	'filterDeleteAllItems': 'Ta bort alla filter',
	'filterDockChevronLeft': 'Bläddra genom data',
	'filterDockChevronRight': 'Bläddra genom data',
	'filterIconLabel_Single': 'Filter',
	'filterIconLabel_Global': 'Alla flikar',
	'filterIconLabel_Tab': 'Den här fliken',
	'filterIconTooltip_Single': 'Filter',
	'filterIconTooltip_Global': 'Filter för alla flikar',
	'filterIconTooltip_Tab': 'Filter för denna flik',
	'filterDropZoneTooltip_Single': 'Filtrera släppzon',
	'filterDropZoneTooltip_Global': 'Filtrera släppzon för alla flikar',
	'filterDropZoneTooltip_Tab': 'Filtrera släppzon för denna flik',
	'filterOverflowMenu': 'Mer',
	'expand': 'Expandera',
	'collapse': 'Komprimera',
	'filterDockItemNameAriaLabel': 'Tryck på Enter för att öppna filterdialogrutan och definiera filtret.',
	'filterItemCanvasMove': 'Lägg till på arbetsyta',
	'filterItemDelete': 'Ta bort filter',
	'filterInvertRange': 'allt utom: %{from}-%{to}',
	'filterRange': '%{from} - %{to}',
	'filter_date_after_except': 'Inte efter %{from}',
	'filter_date_after': 'Efter %{from}',
	'filter_date_before_except': 'Inte före %{to}',
	'filter_date_before': 'Före %{to}',
	'filter_date_between_except': 'Inte mellan %{from} och %{to}',
	'filter_date_between': 'Mellan %{from} och %{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Alla',
	'filterExcept': 'utom %{values}',
	'filterDockToolbarButtonLabel': 'Filterdocka',
	'navigateTitle': 'Navigera till',
	'current_nav_group': 'Aktuell navigeringsgrupp är %{navigation_group_name}',
	'next': 'Nästa',
	'previous': 'Föregående',
	'multiselectMsg': '%{count} valda',
	'errMsgFilterItemMissingTitle': 'Filtervärdena %{itemName} kan inte läsas in eftersom värdena inte är tillgängliga med den här datamängden.',
	'errMsgFilterItemGenericTitle': 'Filtervärden kan inte läsas in',
	'textFilterItemsNotFound': 'Det finns inga tillgängliga objekt.',
	'nullValueLabel': '(tom)',
	'filterConditionLabel': 'Filtervillkor',
	'filter_includesAll': 'Inkluderar alla',
	'filter_allMembersOfSet': 'Alla medlemmar i mängden',
	'modelFilter': 'Filter',
	'filtersTitle': 'Filteregenskaper',
	'search': 'Sök',
	'clearTextFilterValue': 'Rensa',
	'invertFilterSelection': 'Invertera',
	'modellingLoading': 'Läser in...',
	'searchAll': 'Sök efter alla kolumner',
	'toolbarActionPossibleKeyDrivers': 'Ändra omfattning',
	'toolbarActionPossibleKeyDriversSubTitle': 'Dra objekt från vänster som ska inkluderas i analysdiagrammet',
	'toolbarActionSort': 'Sortera',
	'toolbarActionSortAscending': 'Sortera stigande',
	'toolbarActionSortDescending': 'Sortera fallande',
	'toolbarActionSortAuto': 'Automatisk (%{sortOrder})',
	'toolbarActionSortCustom': 'Anpassad',
	'toolbarActionFormat': 'Format',
	'toolbarActionFormatAbbreviation': 'Avrunda',
	'toolbarActionFormatNone': 'Auto',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Högsta eller lägsta',
	'toolbarActionRmvShape': 'Ta bort form',
	'toolbarActionToggleShapeDrop': 'Infografikform',
	'toolbarActionToggleShapeDropTitle': 'Skapa en infografik',
	'toolbarActionToggleShapeDropText': 'Dra en form till det här fältet för att skapa en infografik.',
	'toolbarActionAggregationType': 'Summera',
	'toolbarDeleteActionText': 'Ta bort kolumn',
	'toolbarTextActionText': 'Formatera text',
	'toolbarActionFilterLocalKeepSelected': 'Behåll',
	'toolbarActionFilterLocalExcludeSelected': 'Exkludera',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Enkel beräkning',
	'toolbarActionDrillBack': 'Föregående',
	'toolbarActionDrillUp': 'Borra uppåt',
	'toolbarActionDrillDown': 'Borra nedåt',
	'toolbarActionNavigate': 'Bläddra',
	'toolbarActionCreateFilterGroup': 'Skapa ny anslutning',
	'toolbarActionDisconnectFilterGroup': 'Bryt alla länkar',
	'toolbarActionLinkFilterGroup': 'Lägg till en befintlig anslutning',
	'toolbarActionLassoSelect': 'Välj verktyg',
	'toolbarActionRefreshDeveloperWidget': 'Uppdatera',
	'textFontFamilySubClassHairline': 'Hårfin',
	'textFontFamilySubClassThin': 'Tunn',
	'textFontFamilySubClassThinItalic': 'Tunn kursiv',
	'textFontFamilySubClassExtraLight': 'Extrasmal',
	'textFontFamilySubClassExtraLightItalic': 'Extrasmal kursiv',
	'textFontFamilySubClassLight': 'Ljust',
	'textFontFamilySubClassLightItalic': 'Smal kursiv',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Normal kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Medel',
	'textFontFamilySubClassMediumItalic': 'Medelkursiv',
	'textFontFamilySubClassHeavy': 'Tjock',
	'textFontFamilySubClassHeavyItalic': 'Tjock kursiv',
	'textFontFamilySubClassDemiBold': 'Demifet',
	'textFontFamilySubClassDemiBoldItalic': 'Demifet kursiv',
	'textFontFamilySubClassBold': 'Halvfet',
	'textFontFamilySubClassBoldItalic': 'Halvfet kursiv',
	'textFontFamilySubClassExtraBold': 'Extrafet',
	'textFontFamilySubClassExtraBoldItalic': 'Extrafet kursiv',
	'textFontFamilySubClassBlack': 'Svart',
	'textFontFamilySubClassBlackItalic': 'Svart kursiv',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'stigande',
	'dlg_descending': 'fallande',
	'dlg_custom': 'anpassat',
	'dlg_none': 'ingen',
	'dlg_hierarchy': 'hierarki',
	'dlg_namedSet': 'namngiven mängd',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Ta bort handtag',
	'visualizationLabel': 'Visualisering',
	'chartLabel': '%{chartName} diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Tryck på F12 för att navigera i widgeten',
	'f10KeyDescription': 'Tryck på F10 för att starta widgetfokusvyn',
	'playButtonLabel': 'Kör',
	'dataPlayerValueListLabel': 'Datauppspelningsvärden',
	'localFilterTitle': 'Endast detta objekt',
	'globalFilterTitle': 'Alla objekt',
	'deleteFilter': 'Ta bort filter',
	'editFilter': 'Ändra filter',
	'ariaEditFilterLabel': 'Tryck på Enter för att ändra filtret.',
	'ariaDeleteFilterLabel': 'Tryck på Delete för att ta bort filtret.',
	'measureFilterBetween': 'Mellan %{lowerBound} och %{upperBound}',
	'measureFilterNotBetween': 'Inte mellan %{lowerBound} och %{upperBound}',
	'dimFilterIn': 'Inkluderar %{in}',
	'dimFilterNotIn': 'Exkluderar %{out}',
	'gtFilter': 'Efter %{lowerBound}',
	'ltFilter': 'Före %{upperBound}',
	'ariaEditPrompt': 'Tryck på Enter för att ändra promptvärdet',
	'dataPointFilterTitle': 'Datapunkter',
	'dataPointFilterIncludeSummary': 'Inkluderade %{valueCount} datapunkter',
	'dataPointFilterExcludeSummary': 'Exkluderade %{valueCount} datapunkter',
	'widgetFiltersLabel': 'Widgetfilter',
	'coachMarkTitleSpiralTarget': 'Ändra omfattning',
	'coachMarkContentSpiralTarget': 'Här kan du komma åt och ändra valet av styrfunktioner för målet.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Okända platser:',
	'geomapAmbiguousLocations': 'Tvetydiga regioner:',
	'visualizationNotifications': 'Visualiseringsaviseringar:',
	'dataNotifications': 'Dataaviseringar:',
	'autobinSuggestion': 'Slå på automatisk gruppering',
	'LIVE_empty_visualization_hint_title': 'Skapa visualisering',
	'LIVE_empty_visualization_hint_description': 'Dra data hit eller till fälten.',
	'LIVE_slots_required_field_description': '%{asterisk} Betecknar ett obligatoriskt fält',
	'LIVE_slots_drag_and_drop_description': 'Dra data till fälten ovan för att skapa och filtrera visualiseringen.',
	'dwErrorLoadingAvailableVisualizations': 'Det går inte att läsa in tillgängliga visualiseringsdefinitioner',
	'moreDataIndicator': 'Dina data klipptes av vid %{threshold} objekt. Tillämpa ett filter för att visa färre.',
	'nonCtxTopBottomInvalid': 'Att definiera en regel för högsta/lägsta utan kontext stöds inte för korstabeller. Det har tagits bort från den här korstabellvyn. Definiera om regeln i en eller flera kategorier i kontext med %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Det går inte att läsa in objektet eftersom visualiseringsdefinition saknas.',
	'dwErrorLoadingVisualizationListNotFound': 'Det går inte att läsa in visualiseringen.',
	'dwErrorRunningQuery': 'Det går inte att hämta data från datamängden %{datasetName}.',
	'dwErrorGeoData': 'Det går inte att visa geografiska data i en karta. Välj en annan visualiseringstyp.',
	'dwPromptSignonCancelWarning': 'Data för den här visualiseringen är inte tillgängliga. Fyll i korrekta kreditiv.',
	'dwErrorMissingDataset': 'Det går inte att läsa in visualiseringar eftersom den associerade datamängden \'%{datasetName}\' inte är tillgänglig.',
	'dwErrorRenderingVisualization': 'Det går inte att läsa in den här visualiseringen.',
	'dwErrorVisualizationTooSmall': 'Visualiseringen är för liten för att visa alla data. Gör visualiseringen större eller begränsa datamängden.',
	'errorSourceNotFound': 'Det går inte att läsa in visualiseringen eftersom associerad källa \'%{sourceName}\' inte är tillgänglig.',
	'errorActionNotSupported': 'Den här åtgärden hanteras inte för datakällan \'%{sourceName}\'.',
	'errorMeasureNotSupportedOnMultiEdges': 'Visualiseringen har mått på flera kanter, vilket inte längre stöds. Sätt måtten endast på en kant.',
	'errorExceedAllowableValue': 'Det uppskattade antalet celler överskrider det tillåtna värdet 100000. Tillämpa filtrering på projicerade mängder för att minska antalet celler.',
	'propScaleLabel': 'Antal ikoner',
	'propScaleDescription': 'Välj antal ikoner',
	'propScaleFew': 'Låg',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Hög',
	'lastRefresh': 'Uppdaterades senast för %{timeInterval} sedan',
	'widgetTimer': 'Widgettimer',
	'datasetItemsUnavailable': 'Vissa datamängdsobjekt som används i visualiseringen är inte tillgängliga.',
	'datasetItemUnavailable': 'Det här datamängdsobjektet är inte tillgängligt',
	'retry': 'Försök igen',
	'widgetConditionalFormatLabel': 'Kontroller för växling av villkorsformat',
	'widgetConditionalFormatTitle': 'Ändra färg för villkorsformat',
	'conditionalPalettePickerLabel': 'Fördelning av %{title}-värden',
	'HistogramYAxisTitle': 'Antal',
	'crosstabName': 'Korstabell',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Ej tillämpligt',
	'summaryLabel': '%{label} med värde %{value}',
	'infographicLabel': '%{label} med värde %{value}',
	'warning': 'Varning',
	'swapRowsAndColumns': 'Växla rader och kolumner',
	'hideSummariesLabel': 'Dölj totaler',
	'showSummariesLabel': 'Visa summeringar',
	'hideRowColumn': 'Dölj',
	'showAllRowColumn': 'Visa alla',
	'dataAssetPropertiesLabel': 'Visualiseringsegenskaper',
	'evAdd': 'Lägg till kolumn',
	'evCollapse': 'Komprimera',
	'evColumns': 'Kolumner',
	'evLocalFilters': 'Lokala filter',
	'evExpand': 'Expandera',
	'evFilterTooltip': 'Filter',
	'missingColumn': 'Saknas: %{columnLabel}',
	'missingFiltering': 'Saknade kolumnfilter:',
	'missingDataItem': 'Refererat dataobjekt %{dataItemId} finns inte i widgeten.',
	'heatByLabel': 'Värme efter',
	'toolbarChangeVisualization': 'Ändra visualisering',
	'modellingRelatedTablesNoneFound': 'Inga relaterade tabeller hittades',
	'processing': 'Bearbetar...',
	'errorCellWarning': 'Vissa summavärden kunde inte beräknas.',
	'aggregateTypeToggler': 'Visa aggregeringstyp',
	'maxColumnsExceeded': 'Max antal kolumner har överskridits. %{columns} togs bort.',
	'unboundColumns': 'Det går inte att använda följande kolumner: %{columns}.',
	'unboundColumn': 'Det går inte att använda följande kolumn: %{columns}.',
	'recommendRequestFailed': 'Rekommendationsbegäran misslyckades. Kontakta administratören.',
	'visualizationDoesNotSupportOLAP': 'Det går inte att skapa visualiseringen som baseras på en OLAP-datakälla. Välj en annan hanterad datakälla.',
	'showDataBehindVizLabel': 'Visa data',
	'showDataBehindVizNotSupportedLabel': 'Det går inte att visa data för den här visualiseringstypen',
	'exploreData': 'Utforska...',
	'newExplore': 'Ny utforskning',
	'thumbnails_error_fetching': 'Fel vid hämtning av miniatyrer',
	'loadedThumbnailImage': 'Läste in %{visType}-miniatyrbild för visualisering',
	'autobinAxisLabel': 'grupper',
	'recommended_visualizations': 'Rekommenderade visualiseringar',
	'all_visualizations': 'Alla visualiseringar',
	'edit': 'Redigera',
	'selectTargetDialogTitle': 'Välj ett genomborrningsmål',
	'noTargetInCM': 'Det går inte att hitta genomborrningsmålet',
	'errorDrillDefinition': 'Fel vid tillägg eller ändring av genomborrningsdefinitionen.',
	'errorDrillToTarget': 'Fel vid borrning till %{targetName}',
	'drillThroughMappingViewLabel': 'Tilldela kolumner från din kontrollpanel till prompter för målrapporten',
	'drillthroughScopeRadioLabel': 'Tillämpa den här definitionen för:',
	'drillthroughScopeRadioOptionVisualization': 'Endast den här visualiseringen',
	'drillthroughScopeRadioOptionConnection': 'Visualiseringar i samma anslutning som använder samma datakälla',
	'drillthroughScopeRadioOptionDashboard': 'Visualiseringar i %{perspective} som använder samma datakälla',
	'drillThroughParametersColumnTitle': '%{targetName}-prompter:',
	'drillThroughMetadataColumnTitle': '%{boardName}-datakolumner:',
	'drillThroughDefinitionNoParameter': 'Genomborrningsmålet har inga prompter.',
	'drillThroughDefinitionErrorQueryingReport': 'Korrigera felet med målrapporten och försök sedan skapa genomborrningsdefinitionen igen.',
	'drillThroughDefinitionErrorDlgTitle': 'Något blev fel',
	'dlg_back': 'Gå tillbaka',
	'dlg_close': 'Stäng',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Avbryt',
	'dlg_apply': 'Tillämpa',
	'drillthrough_unsaveMsg': 'Vill du fortsätta utan att spara \'%{name}\'?',
	'drillthrough_jumpTo': 'Genomborrningsdefinition: %{name}',
	'drillthrough_jumpToLabel': 'Borra igenom',
	'drillthrough_manage': 'Hantera...',
	'drillthrough_addNewTarget': 'Lägg till en ny genomborrningsdefinition',
	'drillthrough_manageJumpPaths': 'Hantera genomborrningsdefinitioner',
	'drillthrough_manageJumpPaths_edit': 'Ändra %{name}',
	'drillthrough_manageJumpPaths_delete': 'Ta bort %{name}',
	'drillthrough_manageAddAnotherTarget': 'Lägg till en annan genomborrningsdefinition',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Bekräfta borttagning',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Vill du ta bort genomborrningen %{name}?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplicera genomborrningsnamn',
	'drillthrough_definitionMessage': 'Genomborrningen %{name} finns redan. Ange ett annat namn',
	'drillthrough_jumpToTarget_notFound': 'Mål hittades inte i genomborrningen %{name}',
	'drillThroughDefinitionNoParameterSubTitle': 'Ingen kontext överfördes till målrapporten.',
	'drillthrough_titleLabel': 'Rubrik',
	'drillthrough_subTitle': 'Visualiseringskontexten i din källa används för att filtrera målet %{perspective}.',
	'noPrompt': 'Inga prompter',
	'formatAutoDescription': 'Anger automatiskt formatet som ärvs från datakällan eller visualiseringen.',
	'formatDefaultDescription': 'Standard anger det format som ärvs från systemet',
	'createCustomGroupAction': 'Skapa datagrupp',
	'removeCustomGroupAction': 'Ta bort datagrupp',
	'editCustomGroupAction': 'Ändra datagrupp',
	'renameCustomGroupAction': 'Byt namn på datagrupp',
	'createCustomGroupErrorToast': 'Det gick inte att skapa datagruppen.',
	'removeCustomGroupErrorToast': 'Det gick inte att ta bort datagruppen.',
	'editCustomGroupErrorToast': 'Det gick inte att ändra datagruppen.',
	'renameCustomGroupErrorToast': 'Det gick inte att byta namn på datagruppen.',
	'customGroupLabel': 'Datagrupp',
	'ungroupCustomGroupLabel': 'Dela upp grupp',
	'renameCustomGroupLabel': 'Byt namn',
	'createCustomGroupLabel': 'Skapa',
	'customGroupingLabel': '%{columnLabel} (Grupp)',
	'createCustomSort': 'Skapa anpassad sortering',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Välj tillgängliga objekt och ändra sedan ordningen för att skapa en anpassad sortering.',
	'availableItems': 'Tillgängliga objekt',
	'selectAll': '(Välj alla)',
	'customSortOrder': 'Anpassad sorteringsordning',
	'selectAvailableItemsDesc': 'Välj tillgängliga objekt och ändra ordningen på dem här.',
	'moveToTop': 'Flytta överst',
	'clear': 'Rensa',
	'sortRemainingItemsBy': 'Sortera återstående objekt efter',
	'clearAll': 'Rensa alla',
	'resetTooltip': 'Alla objekt tas bort från listan %{customSortOrder}. Listmenyn %{sortRemainingItemsBy} återgår till standard.',
	'manyItemsWarning': 'Om du väljer många objekt kan prestanda för kontrollpanelen påverkas.',
	'manyItemsSelected': 'Fler än %{maxItems} objekt har valts. Det kan påverka kontrollpanelens prestanda.',
	'somethingWentWrong': 'Något blev fel',
	'unableToLoadItems': 'Det går inte att läsa in tillgängliga objekt.',
	'tryAgain': 'Försök igen',
	'customSortLabel': 'Anpassad sortering',
	'applyError': 'Det går inte att tillämpa %{action}.',
	'searchReturnedNoResults': 'Sökningen gav inte något resultat.',
	'tryDifferentSearchTerm': 'Försök med en annan sökterm',
	'extVisSystem': 'System',
	'extVisCustom': 'Anpassad',
	'customVisTestVisualization': 'Testa visualisering',
	'extVisCustomVisPreview': 'förhandsgranskning',
	'extVisCustomPreviewWidgets': 'Utvecklarwidgetar',
	'extVisCustomVVisualization': 'Visualisering',
	'extVisCustomVisuals': 'Anpassade visualiseringar',
	'noPermissionToManage': 'Du har inte behörighet att hantera anpassade visualiseringar.',
	'extVisCustomUpdate': 'Uppdatera',
	'extVisCustomDelete': 'Ta bort',
	'extVisNoCustomVisuals': 'Ingen anpassad visualisering',
	'extVisNoCustomVisualsMsg': 'Det finns inga anpassade visualiseringar i organisationen',
	'extVisAddCustomVisual': 'Lägg till anpassad visualisering',
	'extVisNoCustomVisualsAdminMsg': 'Det finns inga anpassade visualiseringar. Lägg till en.',
	'extVisNoSDKConnection': 'Ingen anslutning har skapats till den lokala filen',
	'extVisNoSDKPreviewMsg': 'Upprätta en anslutning om du vill granska visualiseringarna.',
	'extVisMore': 'Mer',
	'extVisDeleteDialogTitle': 'Ta bort anpassad visualisering',
	'extVisDeleteDialogBody': 'Vill du ta bort den anpassade visualiseringen? Den kan användas av andra kontrollpaneler och rapporter.',
	'extVisDeleteConfirmation': 'Den anpassade visualiseringen togs bort.',
	'extVisDeleteError': 'Det gick inte att ta bort den anpassade visualiseringen. %{msg}',
	'extVisCloseToast': 'Stäng nu',
	'extVisAdd': 'Den anpassade visualiseringen lades till.',
	'extVisAddError': 'Det gick inte att lägga till den anpassade visualiseringen. %{msg}',
	'extVisUpdate': 'Den anpassade visualiseringen uppdaterades.',
	'extVisUpdateError': 'Det gick inte att uppdatera den anpassade visualiseringen. %{msg}',
	'extVisAddProgress': 'Importerar %{name}',
	'extVisUpdateProgress': 'Uppdaterar %{name}',
	'extPermissionTitle': 'Begränsad åtkomst eller borttagen anpassad visualisering',
	'extPermissionBody': 'Den anpassade visualiseringen kan inte visas eftersom den har tagits bort eller har begränsad åtkomst.',
	'customVizSaveWarning': 'Det går inte att spara de anpassade visualiseringarna. De har inte importerats.',
	'schematicTestCaption': 'Testa schematik',
	'schematicServiceRequestError': 'Schematiktjänstfel',
	'extVisPreviewMessage': 'Det här är en förhandsgranskning. Visualiseringen har inte lagts till produkten ännu.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Odefinierat',
	'kpiDefaultTargetLabel': 'Mål',
	'kpiNonNumericTarget': 'Målvärdet måste vara ett tal.',
	'kpiManualTargetSlotFilled': 'Värde tillämpat i fält',
	'kpiAutoValueSize': 'Auto',
	'kpiUnableDrawSparklineLabel': 'Det går inte att rita miniatyr',
	'kpiUnableDrawSparklineInfo': 'En miniatyr kräver minst två tidspunkter. Ändra data eller justera filtren för att visa miniatyren.',
	'conditionalFormattingEnabled': 'Villkorlig färg',
	'currentConditionalPalette': 'Aktuell villkorspalett',
	'sectionName_range': 'Ange intervall',
	'rangeScaleLabel': 'Skala',
	'rangeScalePercentage': 'Procent',
	'rangeScaleNumeric': 'Numerisk',
	'numberOfSteps': 'Antal intervall',
	'conditionalFormattingSelectedStep': 'Valt intervall',
	'conditionalFormattingStartValue': 'Startvärde',
	'conditionalFormattingEndValue': 'Slutvärde',
	'conditionalFormattingTextColor': 'Textfärg',
	'conditionalFormattingMin': 'Min',
	'conditionalFormattingMax': 'Max',
	'conditionalFormattingNonNumericValue': 'Värdet måste vara numeriskt.',
	'conditionalFormattingStepIndexInvalid': 'Ogiltigt intervallindex.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'Värdet måste ligga i intervallet %{start} - %{end}.',
	'conditionalFormattingValueShouldBeLower': 'Värdet måste vara mindre än eller lika med %{value}.',
	'conditionalFormattingValueSouldBeHigher': 'Värdet måste vara större än eller lika med %{value}.',
	'conditionalFormattingDeleteStep': 'Ta bort valt intervall',
	'conditionalFormattingRestoreSteps': 'Återställ intervall',
	'conditionalFormattingReversePalette': 'Vänd om färger',
	'conditionalFormattingShapeIndicator': 'Indikatorform',
	'conditionalFormattingIconNone': 'Ingen form',
	'conditionalFormattingIconArrowUp': 'Pil upp',
	'conditionalFormattingIconArrowRight': 'Pil höger',
	'conditionalFormattingIconArrowDown': 'Pil ned',
	'conditionalFormattingIconCaretUp': 'Tak upp',
	'conditionalFormattingIconDash': 'Streck',
	'conditionalFormattingIconCaretDown': 'Tak ned',
	'conditionalFormattingIconCheckmark': 'Bockmarkering',
	'conditionalFormattingIconWarning': 'Varning',
	'conditionalFormattingIconXSymbol': 'X-symbol',
	'conditionalFormattingIconCircle': 'Cirkel',
	'conditionalFormattingIconTriangle': 'Triangel',
	'conditionalFormattingIconDiamond': 'Romb',
	'conditionalFormattingIconFaceSatisfied': 'Nöjd',
	'conditionalFormattingIconFaceNeutral': 'Neutral',
	'conditionalFormattingIconFaceDissatisfied': 'Missnöjd',
	'suppression': 'Undertryckning',
	'suppressNone': 'Inget',
	'suppressRowsAndColumns': 'Rader och kolumner',
	'suppressRows': 'Rader',
	'suppressColumns': 'Kolumner',
	'enableSuppression': 'Aktivera undertryckning',
	'disableSuppression': 'Avaktivera undertryckning',
	'loadVisDefinitionError': 'Det går inte att läsa in definitionen för visualisering %{id}',
	'emptyVisualization': 'Tom visualisering',
	'expandCollapse': 'Expandera och komprimera',
	'expandBtnLabel': 'Expandera',
	'collapseBtnLabel': 'Komprimera',
	'prop_sizeInputNonNumericValue': 'Värdet måste vara numeriskt.',
	'prop_sizeValueShouldBeHigher': 'Värdet måste vara större än %{value}.',
	'fontPropLabel': 'Teckensnitt',
	'fontSizePropLabel': 'Teckenstorlek',
	'sectionItemAxisTitle': 'Objektaxelrubrik',
	'sectionItemAxisLabel': 'Objektaxeletikett',
	'sectionValueAxisTitle': 'Värdeaxelrubrik',
	'sectionValueAxisLabel': 'Värdeaxeletikett',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Visualisering',
	'ds-missingDataSet': 'Kunde inte hitta datamängd. Kontrollera att datamängden har skapats.',
	'ds-missingDashboardId': 'Spara kontrollpanelen innan du skapar datamängden.',
	'ds-unsupportedDataSourceType': 'Datakälltypen %{type} hanteras inte.'
});
